// export default (): void => {
// 	const logoCanvas = document.querySelector("#canvas");
// 	if (logoCanvas == null) return;
// 	import(/* webpackChunkName: "abcd8 logo" */ "../classes/abcd8LogoClass")
// 		.then(({ default: abcd8Logo }) => {
// 			new abcd8Logo(logoCanvas as HTMLCanvasElement);
// 		})
// 		.catch(() => "An error with abcd8Logo occurred");
// };
export default () => {
    const navCanvases = [
        ...document.querySelectorAll(".canvas-nav")
    ];
    if (navCanvases.length === 0)
        return;
    import(/* webpackChunkName: "abcd8 logo" */ "../classes/abcd8LogoClass")
        .then(({ default: Abcd8Logo }) => {
        navCanvases.forEach(canvas => new Abcd8Logo(canvas));
    })
        .catch(() => console.error("An error with abcd8Logo occurred"));
};
